import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import Scrollbars from "react-custom-scrollbars-2";
import {
  getBackups,
  getRestoreProgress,
  restoreBackupFile,
} from "../../services/dataWarehouse.service";
import moment from "moment";
import {
  Button,
  DropBox,
  FormHeader,
  InputBox,
  TabComponent,
} from "../../../../components";
import {
  clearSelectBackup,
  setSelectBackupFile,
  setSelectDB,
} from "../../redux/actions";
import { CheckValidity } from "../../../../utils/formValidity";
import { Store } from "react-notifications-component";
import { Progress } from "antd";

const BackUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [backupsList, setBackupsList] = useState([]);
  const [dbSelect, setDBSelect] = useState("existingDB");
  const [progress, setProgress] = useState(0);

  const [formData, setFormData] = useState({
    database: {
      key: "database",
      label: "Select Database",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column align-content-center ",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    databaseName: {
      key: "databaseName",
      label: "Database name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { databaseList, selectDB, selectBackup, selectDatabase, dbTypes } =
    useSelector(({ warehouseReducer }) => warehouseReducer);

  const handleChange = async (event, inputIdentity) => {
    const updateNewProductForm = {
      ...formData,
    };

    updateNewProductForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewProductForm[inputIdentity].value,
      updateNewProductForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewProductForm[inputIdentity].isValid = validityRes.isValid;
      updateNewProductForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewProductForm[inputIdentity].value = event;
      updateNewProductForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewProductForm) {
        formIsValid =
          updateNewProductForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewProductForm);
    }
  };

  const dispatch = useDispatch();

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const onClickRestore = async () => {
    try {
      setIsLoading(true);

      const updatedForm = { ...formData };

      if (selectBackup === "") {
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Select Backup file!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        return;
      }

      if (dbSelect === "existingDB" && updatedForm.database.value === "") {
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Select Database!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        return;
      }
      if (dbSelect === "newDB" && updatedForm.databaseName.value === "") {
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Create Database or Select a Database!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
        return;
      }

      let body = {
        db_type: dbTypes.find((dbType) => dbType.value === selectDB)
          ?.displayValue,
        db_name:
          dbSelect === "existingDB"
            ? updatedForm.database.value
            : updatedForm.databaseName.value,
        config_file: selectDB,
        backup_file_path: selectBackup?.path,
      };

      const response = await restoreBackupFile(body);
      const restoreId = response?.data?.restore_id;
      if (!restoreId) return;

      const interval = setInterval(async () => {
        const progressResponse = await getRestoreProgress(restoreId);
        setProgress(0);
        const percentage = progressResponse.data?.progress || 0;
        setProgress(percentage);

        if (percentage >= 100) {
          clearInterval(interval);
          setIsLoading(false);
          dispatch(clearSelectBackup());
        }
      }, 1000);
    } catch (error) {
      console.error("Restore failed", error);
      setIsLoading(false);
    }
  };

  const updateForm = { ...formData };

  const onChange = (key) => {
    console.log(key);
    setDBSelect(key);
  };

  const items = [
    {
      key: "existingDB",
      label: "🔍 Existing DB",
      children: (
        <div
          className="mt-2 d-flex flex-column"
          style={{ width: "100%", gap: "16px", padding: "0 40px 0 12px" }}
        >
          <div style={{ minWidth: "85%" }}>
            <DropBox
              data={updateForm.database}
              onChange={(e) => {
                const updateForm = { ...formData };
                console.log({ e });
                updateForm["database"].value = e;
                setFormData(updateForm);
                // dispatch(setSelectDB(e));
              }}
            />
          </div>
          <Button
            data={{
              mainLayerStyles: "",
              btnName: "Restore",
              buttonType: "primary",
              buttonSize: "xs",
              isLoading: isLoading,
              disable: false,
            }}
            onClick={async (e) => {
              await onClickRestore();
            }}
          />
        </div>
      ),
    },
    {
      key: "newDB",
      label: "🧩 Create new DB",
      children: (
        <div
          className="mt-2 d-flex flex-column"
          style={{ width: "100%", gap: "16px", padding: "0 40px 0 12px" }}
        >
          <div style={{ minWidth: "85%" }}>
            <InputBox
              data={updateForm.databaseName}
              onChange={async (e) => {
                e.preventDefault();
                await handleChange(e.target.value, updateForm.databaseName.key);
              }}
            />
          </div>
          <Button
            data={{
              mainLayerStyles: "",
              btnName: "Create & Restore",
              buttonType: "primary",
              buttonSize: "xs",
              isLoading: isLoading,
              disable: false,
            }}
            onClick={async (e) => {
              await onClickRestore();
            }}
          />
        </div>
      ),
    },
  ];

  const fetchBackups = async (fileName) => {
    try {
      let body = {
        db_type: dbTypes.find((dbType) => dbType.value === fileName)
          ?.displayValue,
      };
      const response = await getBackups(body?.db_type);
      console.log("getBackups : ", response);
      if (response?.data?.status) {
        setBackupsList(response?.data?.files);
      } else {
        console.log("Data Not Found");
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error fetching Data", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectDB) {
      fetchBackups(selectDB);
    }
  }, [selectDB]);

  useEffect(() => {
    if (databaseList?.length > 0) {
      const updateForm = { ...formData };
      updateForm["database"].elementConfig.options = databaseList;
      setFormData(updateForm);
    }
  }, [databaseList]);

  return (
    <>
      <div className="row">
        <div className="col-7 jb-category-body-wrapper">
          <Scrollbars
            onScroll={handleOnScroll}
            renderView={(props) => (
              <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
            )}
            style={{ height: viewPointHeight - 310 }}
          >
            <div className="table-list-wrapper">
              {isLoading ? (
                <div className="loading">Loading...</div>
              ) : (
                backupsList.map((file, index) => (
                  <div
                    className="d-flex flex-row align-items-center justify-content-between p-2"
                    style={{
                      background:
                        selectBackup?.file_name === file?.file_name
                          ? "#c40a4a42"
                          : "",
                    }}
                  >
                    <div
                      key={index}
                      className={`table-item ${
                        selectBackup?.file_name === file?.file_name
                          ? "active"
                          : ""
                      }`}
                    >
                      {/* 🧩 Backup_{" "}
                      {moment(file?.date).format("DD") +
                        "_" +
                        moment(file?.date).format("MMM")} */}
                      <div className="table-item-main">
                        {" "}
                        🧩 Backup_{" "}
                        {moment(file?.date).format("DD") +
                          "_" +
                          moment(file?.date).format("MMM")}
                        {" (" + file?.file_name + ")"}
                      </div>
                      <div className="table-item-sub">
                        {moment(file?.date).format("MMMM Do YYYY, h:mm a")}
                      </div>
                    </div>
                    <Button
                      data={{
                        mainLayerStyles: "",
                        btnName: "Restore",
                        buttonType: "secondary s-border",
                        buttonSize: "xs",
                        isLoading: isLoading,
                        disable: false,
                      }}
                      onClick={() => {
                        dispatch(setSelectBackupFile(file));
                      }}
                    />
                  </div>
                ))
              )}
            </div>
          </Scrollbars>
        </div>
        <div className="col-5 pt-3">
          <FormHeader
            data={{
              formHeader: "Restore database",
              size: "md-sm ml-2",
            }}
          />
          {selectBackup && (
            <div className={`table-item mt-4 mb-2`}>
              <div className="d-flex flex-column p-1">
                <div className="table-item-main">
                  {" "}
                  🧩 Backup_{" "}
                  {moment(selectBackup?.date).format("DD") +
                    "_" +
                    moment(selectBackup?.date).format("MMM")}
                </div>
                <div className="table-item-sub">
                  {moment(selectBackup?.date).format("MMMM Do YYYY, h:mm a")}
                </div>
              </div>
            </div>
          )}
          <TabComponent items={items} onChange={onChange} />
          {progress > 0 && (
            <div
              className="d-flex flex-column justify-content-center align-items-center mt-3"
              style={{ width: "320px" }}
            >
              <Progress
                percent={progress}
                showInfo={false}
                strokeColor=" #C40B4A"
                trailColor=" #FA1C690A"
              />
              <span className="mt-2">{progress}%</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default withRouter(BackUp);
